module.exports = "<div class=loading-overlay> <div class=lo-content-wrap> <div class=lo-content> <i class=\"fa fa-spinner fa-5x fa-pulse\"></i> <div class=q-marg-top-xl> <h2> Loading... </h2> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/sharedHtml/loaderOverlay.html
// module id = 308
// module chunks = 1